@if (report) {
  @switch (report.process) {
    @case ('FIRST_REPORT') {
      <app-your-first-report [report]="asFirstReportData(report)"></app-your-first-report>
    }
    @case ('TOP_10') {
      <app-top-10-report [report]="asTop10Data(report)"></app-top-10-report>
    }
    @case ('AML_WALLET_CHECK') {
      <app-aml-wallet-report [report]="asAmlWalletData(report)"></app-aml-wallet-report>
    }
    @case ('MONITORING_WALLET_CHECK') {
      <app-aml-wallet-report [report]="asAmlWalletData(report)"></app-aml-wallet-report>
    }
  }
}
@if (transaction) {
  <app-transaction-report [transaction]="transaction" [process]="'INCOMING_TRANSACTION'"></app-transaction-report>
}
